import { render, staticRenderFns } from "./GroupDialogs.vue?vue&type=template&id=232fbddc"
import script from "./GroupDialogs.vue?vue&type=script&lang=js"
export * from "./GroupDialogs.vue?vue&type=script&lang=js"
import style0 from "./GroupDialogs.vue?vue&type=style&index=0&id=232fbddc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports